import { render, staticRenderFns } from "./Course-Type-Create.vue?vue&type=template&id=c8680956"
import script from "./Course-Type-Create.vue?vue&type=script&lang=js"
export * from "./Course-Type-Create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports